import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from "formik";
import { format as formatDate } from "date-fns-tz";
import { DATE_FORMAT } from "../../date-picker/date";
import { FieldError } from "../atoms/field-error";
import { Signature } from "../atoms/signature";
const STROKE_DATA_NAME = "strokeData";
/**
 * A formik field for capturing user signatures.
 *
 * @param {SignatureFieldProps} props The props for the component.
 * @returns {JSX.Element} The rendered signature field component.
 */
export const SignatureField = ({ name, signDateRef, disabled, label, onChange, onError, transformUrl, }) => (_jsx(Field, { name: name, children: ({ form, field }) => (_jsxs(_Fragment, { children: [_jsx(Signature, { transformUrl: transformUrl, value: field.value, disabled: disabled, onChange: (value, strokeData) => {
                    if (onChange) {
                        onChange(value, form);
                        form.setFieldValue(STROKE_DATA_NAME, strokeData);
                        return;
                    }
                    form.setFieldValue(name, value);
                    form.setFieldValue(STROKE_DATA_NAME, strokeData);
                    signDateRef &&
                        form.setFieldValue(signDateRef, formatDate(new Date(), DATE_FORMAT.ISO_DATE));
                }, onError: onError, label: label, testId: field.name }), _jsx(FieldError, { name: name })] })) }));
SignatureField.defaultProps = {
    transformUrl: (url) => url,
};
